import { SET_FAQ_CONTENT, SIGNOUT_USER } from 'constants/ActionTypes';

const INITIAL_STATE = {
	faqContent: []
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case SIGNOUT_USER:
			return INITIAL_STATE;
		case SET_FAQ_CONTENT:
			return { ...state, faqContent: action.payload.faqContent };
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./reducers/Content.js